var isMobile=false;
if($(window).width() < 768 ){isMobile=true;}

$(function() {
     setTimeout(function(){
    $(".section__dots").show();
     }, 1600);
});


function scrollToElem(Bullet,selector,sectionoffset,sectionoffsetMobile) {

    var offset = $('.nav__menu').height();
    var window_offset = $(selector).offset().top;

    var tmpoffset=sectionoffset;
    if($(window).width() < 768 ){isMobile=true;tmpoffset=sectionoffsetMobile;}
   window.scroll(0, window_offset - offset-100-tmpoffset);
  setTimeout(function(){
   $(".section__dot").removeClass("active");
    $(Bullet).addClass("active");
     }, 100);

}



    var waypoint1 = new Waypoint({
  element: document.getElementById('header-container'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((1)-1)+")").addClass("active");
  },
  offset: -10
});
    var waypoint2 = new Waypoint({
  element: document.getElementById('s01'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((2)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint3 = new Waypoint({
  element: document.getElementById('p3'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((3)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint4 = new Waypoint({
  element: document.getElementById('p4'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((4)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint5 = new Waypoint({
  element: document.getElementById('p5'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((5)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint6 = new Waypoint({
  element: document.getElementById('p6'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((6)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint7 = new Waypoint({
  element: document.getElementById('p7'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((7)-1)+")").addClass("active");
  },
  offset: 100
});
    var waypoint8 = new Waypoint({
  element: document.getElementById('p8'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((8)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint9 = new Waypoint({
  element: document.getElementById('p9'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((9)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint10 = new Waypoint({
  element: document.getElementById('p10'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((10)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint11 = new Waypoint({
  element: document.getElementById('cta'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((11)-1)+")").addClass("active");
  },
  offset: 180
});
    var waypoint12 = new Waypoint({
  element: document.getElementById('brand-video'),
  handler: function() {
    $(".section__dot").removeClass("active");
    $(".section__dot:eq("+((12)-1)+")").addClass("active");
  },
  offset: ((isMobile)? 75:0 )
});